import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface LeventState {
  [key: string]: number; // Assuming the value is a timestamp
}

const initialState: LeventState = {};

const leventSlice = createSlice({
  name: "levent",
  initialState,
  reducers: {
    fireEvent: (state, action: PayloadAction<{ event: string }>) => {
      const { event } = action.payload;
      state[event] = Date.now();
    },
  },
});

export const { fireEvent } = leventSlice.actions;

export default leventSlice.reducer;
